module.exports = __webpack_public_path__ + "static/media/Like.5b43ea89.svg";